import { render, staticRenderFns } from "./ProductInquiryOrderInfo.vue?vue&type=template&id=22805764&"
import script from "./ProductInquiryOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./ProductInquiryOrderInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports